import CustomDrawer from 'components/commom/CustomDrawer';
import { useEffect, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { CircularProgress, IconButton } from '@mui/material';
import LabelWithInput from 'components/commom/LabelWithPracticeInput';
import 'assets/styles/common.scss';
import SelectInput from 'components/commom/SelectInput';
import { useDispatch, useSelector } from 'react-redux';
import CommonToast from 'components/commom/CommonToast';
import { useNavigate } from 'react-router-dom';
import { getDoctorDrop } from 'store/getDoctorListDropdown/getDoctorListDropdownAction';
import { ClearTokenRedirectLogin } from 'utils/general';
import { createLocationCallAPI } from 'store/EnterpriseAdmin/Location/createLocation/action';
import { updateLocationCallAPI } from 'store/EnterpriseAdmin/Location/updateLocation/action';

const CreateLocation = ({ open, onClose, countryData, editData }) => {
  const dispatch = useDispatch();
  const { showToast } = CommonToast();
  const navigate = useNavigate();
  const [formValue, setFormValue] = useState({
    address: '',
    country: '',
    state: '',
    city: '',
    postalCode: '',
    locationName: '',
  });
  const [formSlug, setFormSlug] = useState({
    country: '',
    state: '',
    city: '',
  });
  const [stateData, setStateData] = useState({});
  const [cityData, setCityData] = useState({});

  const createLoader = useSelector(
    (state) => state?.createLocationReducer?.loading
  );
  const updateLoader = useSelector(
    (state) => state?.updateLocationReducer?.loading
  );
  const enterpriseData = useSelector(
    (state) => state?.getEnterpriseProfileReducer?.users?.data
  );

  useEffect(() => {
    if (open) {
      initialState();
    }
  }, [open]);

  const initialState = () => {
    setFormValue({
      address: editData?.id ? editData?.address : '',
      country: editData?.id ? editData?.country : '',
      state: editData?.id ? editData?.state : '',
      city: editData?.id ? editData?.city : '',
      postalCode: editData?.id ? editData?.postal_code : '',
      locationName: editData?.id ? editData?.name : '',
    });
    if (editData?.id) {
      const countryObj = countryData?.find(
        (item) => item?.name === editData?.country
      );
      const countryId = countryObj?.id || '';
      if (countryId) {
        setFormSlug((prev) => ({
          ...prev,
          ['country']: countryId,
        }));
        getStateCityData(countryObj, 'country', true);
      }
    } else {
      setFormSlug({
        country: '',
        state: '',
        city: '',
      });
      setStateData({});
      setCityData({});
    }
  };

  const handleBack = () => {
    onClose();
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    if (name === 'country' || name === 'state' || name === 'city') {
      if (name === 'country') {
        setFormValue((prev) => ({
          ...prev,
          [name]: value?.name,
          ['state']: '',
          ['city']: '',
        }));
        setFormSlug((prev) => ({
          ...prev,
          [name]: value?.id,
          ['state']: '',
          ['city']: '',
        }));
        getStateCityData(value, 'country');
      }
      if (name === 'state') {
        setFormValue((prev) => ({
          ...prev,
          [name]: value?.name,
          ['city']: '',
        }));
        setFormSlug((prev) => ({
          ...prev,
          [name]: value?.id,
          ['city']: '',
        }));
        getStateCityData(value, 'state');
      }
      if (name === 'city') {
        setFormValue((prev) => ({
          ...prev,
          [name]: value?.name,
        }));
        setFormSlug((prev) => ({
          ...prev,
          [name]: value?.id,
        }));
        getStateCityData(value, 'state');
      }
    } else {
      setFormValue((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const getStateCity = (data, type) => {
    if (type === 'state') {
      setStateData(data);
      const stateObj = data?.find((item) => item?.name === editData?.state);
      const stateId = stateObj?.id || '';
      if (stateId) {
        setFormSlug((prev) => ({
          ...prev,
          ['state']: stateId,
        }));
        getStateCityData(stateObj, 'state', true);
      }
    }
    if (type === 'city') {
      setCityData(data);
      const cityObj = cityData?.find((item) => item?.name === editData?.city);
      const cityId = cityObj?.id || '';
      if (cityId) {
        setFormSlug((prev) => ({
          ...prev,
          ['city']: cityId,
        }));
      }
    }
  };

  const getStateCityData = (data, type, fromEdit = false) => {
    dispatch(
      getDoctorDrop(
        {
          run: true,
          handleFunction: (res) => {
            if (editData?.id) {
              if (type === 'country') {
                getStateCity(res?.data, 'state');
              }
              if (type === 'state') {
                getStateCity(res?.data, 'city');
              }
            } else {
              if (type === 'country') {
                setStateData(res?.data);
              }
              if (type === 'state') {
                setCityData(res?.data);
              }
            }
          },
          authorize: true,
          handleAuthorizeFunction: (res) => {
            ClearTokenRedirectLogin(navigate);
          },
          error: true,
          handleErrorFunction: (res) => {
            showToast(res?.message, 'error');
          },
        },
        `${
          type === 'country'
            ? data?.id
            : fromEdit
              ? countryData?.find((item) => item?.name === editData?.country)
                  ?.id
              : formSlug?.country
        }`,
        `${type === 'state' ? data?.id : ''}`
      )
    );
  };

  const handleSave = () => {
    if (
      !formValue?.address ||
      !formValue?.city ||
      !formValue?.state ||
      !formValue?.country ||
      !formValue?.postalCode
    ) {
      showToast('Please fill all the required fields', 'error');
      return;
    }
    const body = {
      id: editData?.id,
      detail: {
        name: formValue?.locationName
          ? formValue?.locationName
          : enterpriseData?.enterprise?.enterprise_name,
        address: formValue?.address,
        city: formValue?.city,
        state: formValue?.state,
        country: formValue?.country,
        postal_code: formValue?.postalCode,
      },
      enterpriseId: enterpriseData?.enterprise?.enterprise_id,
    };

    if (editData?.id) {
      dispatch(
        updateLocationCallAPI(body, {
          run: true,
          handleFunction: (res) => {
            showToast(res?.message, 'success');
            handleBack();
          },
          authorize: true,
          handleAuthorizeFunction: (res) => {
            ClearTokenRedirectLogin(navigate);
          },
          error: true,
          handleErrorFunction: (res) => {
            showToast(res?.message, 'error');
          },
        })
      );
    } else {
      dispatch(
        createLocationCallAPI(body, {
          run: true,
          handleFunction: (res) => {
            showToast(res?.message, 'success');
            handleBack();
          },
          authorize: true,
          handleAuthorizeFunction: (res) => {
            ClearTokenRedirectLogin(navigate);
          },
          error: true,
          handleErrorFunction: (res) => {
            showToast(res?.message, 'error');
          },
        })
      );
    }
  };

  return (
    <CustomDrawer
      open={open}
      onClose={() => {
        handleBack();
      }}
      width={{ xs: '100vw', md: '70vw', xl: '40vw' }}
    >
      <div className="relative h-full min-h-[400px] flex flex-col">
        <div className="flex-1 overflow-y-auto p-[25px] pb-[15%]">
          <div className="mt-[43px]">
            <div className="flex items-center justify-between gap-[20px]">
              <p className="p-0 m-0 text-[24px] text-[#292D32] family_outfit_semiBold_600 lh-176">
                Add Location
              </p>
              <IconButton onClick={handleBack}>
                <CloseIcon />
              </IconButton>
            </div>
            <div className="mt-[24px]">
              <LabelWithInput
                label={<>Location Name</>}
                placeholder="Location Name"
                name="locationName"
                type="text"
                value={formValue?.locationName}
                onChange={(e) => handleInputChange(e)}
              />
            </div>
            <div className="mt-[16px]">
              <LabelWithInput
                label={
                  <>
                    Address <span style={{ color: 'red' }}>*</span>
                  </>
                }
                placeholder="Address"
                name="address"
                type="text"
                value={formValue?.address}
                onChange={(e) => handleInputChange(e)}
              />
            </div>
            <div className="mt-[16px]">
              <SelectInput
                label={
                  <>
                    Country <span style={{ color: 'red' }}>*</span>
                  </>
                }
                placeholder={'Country'}
                colorIcon={'#292D32'}
                name={'country'}
                value={formValue?.country}
                data={countryData || []}
                onChange={handleInputChange}
              />
            </div>
            <div className="mt-[16px]">
              <SelectInput
                label={
                  <>
                    State <span style={{ color: 'red' }}>*</span>
                  </>
                }
                placeholder={'State'}
                colorIcon={'#292D32'}
                name={'state'}
                value={formValue?.state}
                data={stateData || []}
                onChange={handleInputChange}
                disabled={!formValue?.country?.length}
              />
            </div>
            <div className="mt-[16px]">
              <SelectInput
                label={
                  <>
                    City <span style={{ color: 'red' }}>*</span>
                  </>
                }
                placeholder={'City'}
                colorIcon={'#292D32'}
                name={'city'}
                value={formValue?.city}
                data={cityData || []}
                onChange={handleInputChange}
                disabled={!formValue?.state?.length}
              />
            </div>
            <div className="mt-[16px]">
              <LabelWithInput
                label={
                  <>
                    Postal Code <span style={{ color: 'red' }}>*</span>
                  </>
                }
                placeholder="Postal Code"
                name="postalCode"
                type="text"
                value={formValue?.postalCode}
                onChange={(e) => handleInputChange(e)}
              />
            </div>
          </div>
        </div>
        {/* Absolutely Positioned Bottom Button */}
        <div
          className="mt-[30px] absolute left-0 bottom-0 w-full bg-[#375241] p-[30px] cursor-pointer"
          onClick={() => {
            !createLoader && !updateLoader && handleSave();
          }}
        >
          <div className="text-[24px] text-white family_outfit_semiBold_600 lh-176 text-center flex items-center justify-center gap-[10px]">
            {'Save'}
            {createLoader || updateLoader ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              <span
                style={{ width: 24, height: 24, display: 'inline-block' }}
              />
            )}
          </div>
        </div>
      </div>
    </CustomDrawer>
  );
};

export default CreateLocation;
